/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.copilot.rpc.v2.CopilotMessageService
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

/**
 *  Represents feedback provided for a copilot message.
 */

/**
 *  Request to get a message by its ID.
 */

/**
 *  Response for getting a message by its ID.
 */

export const updateFeedbackRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotMessageService',
  rpcName: 'updateFeedback',
  auth: 'app',
  fingerprint: 'XukbbplrNmZUcwZaml2OH5wP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};
export const getMessageByIdRpc = {
  serviceName: 'com.hubspot.copilot.rpc.v2.CopilotMessageService',
  rpcName: 'getMessageById',
  auth: 'app',
  fingerprint: 'NvrAWWitnsXUlTndkzON6ZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false
};